{
  "basicTerms": {
    "selectedOfTotal": "Đã chọn {selected}/{total}",
    "search": "Tìm kiếm",
    "summary": "Tóm tắt",
    "insights": "Thông tin chi tiết",
    "help": "Trợ giúp",
    "expand": "Mở rộng",
    "collapse": "Thu gọn",
    "menu": "Menu",
    "account": "Tài khoản",
    "logout": "Đăng xuất",
    "signIn": "Đăng nhập",
    "days": "Ngày | Ngày",
    "phone": "Điện thoại",
    "subscribers": "Người nhận | Người nhận",
    "favorites": "Yêu thích | Yêu thích",
    "others": "Khác | Khác",
    "yes": "Có",
    "no": "Không",
    "locations": "Địa điểm | Địa điểm",
    "active": "Đang hoạt động",
    "inactive": "Không hoạt động",
    "all": "Tất cả",
    "view": "Xem",
    "language": "Ngôn ngữ",
    "required": "Bắt buộc",
    "timezone": "Múi giờ",
    "new": "Mới",
    "open": "Mở",
    "close": "Đóng",
    "closed": "Đã đóng",
    "occupied": "Đang sử dụng",
    "reserved": "Đã đặt trước",
    "enabled": "Đã bật",
    "disabled": "Đã tắt",
    "enable": "Bật",
    "disable": "Tắt",
    "print": "In",
    "download": "Tải xuống",
    "zoomIn": "Phóng to",
    "zoomOut": "Thu nhỏ",
    "previous": "Trước",
    "next": "Tiếp theo",
    "version": "Phiên bản",
    "setup": "Thiết lập",
    "caution": "Thận trọng",
    "notes": "Ghi chú | Ghi chú",
    "add": "Thêm",
    "remove": "Xóa",
    "duration": "Thời lượng",
    "link": "Liên kết",
    "unlink": "Hủy liên kết",
    "to": "Đến",
    "success": "Thành công",
    "error": "Lỗi",
    "info": "Thông tin",
    "warning": "Cảnh báo",
    "time": "Thời gian",
    "saved": "Đã lưu",
    "forms": "Biểu mẫu | Biểu mẫu",
    "is": "là",
    "only": "Chỉ",
    "saving": "Đang lưu",
    "text": "văn bản",
    "zip": "zip",
    "spreadsheet": "bảng tính",
    "image": "Hình ảnh",
    "cloning": "Đang sao chép",
    "clone": "Sao chép",
    "added": "Đã thêm",
    "removed": "Đã xóa",
    "planned": "Có kế hoạch",
    "unplanned": "Không có kế hoạch",
    "checkedIn": "Đã check-in",
    "checkedOut": "Đã check-out",
    "more": "Thêm",
    "okay": "Đồng ý",
    "reschedule": "Đổi lịch",
    "results": "Kết quả | Kết quả",
    "none": "Không có",
    "pages": "Trang | Trang",
    "pageOfTotal": "Trang {current} / {total}",
    "of": "trên",
    "default": "Mặc định",
    "soon": "sắp có",
    "grid": "Lưới",
    "list": "Danh sách",
    "booked": "Đã đặt",
    "arrivals": "Lượt đến | Lượt đến",
    "early": "Sớm",
    "late": "Trễ",
    "onTime": "Đúng giờ",
    "area": "Khu vực | Khu vực",
    "spot": "Vị trí",
    "single": "Đơn",
    "multiple": "Nhiều",
    "filter": "Bộ lọc",
    "board": "Bảng",
    "at": "lúc",
    "from": "Từ",
    "recent": "Gần đây",
    "delivered": "Đã giao",
    "sent": "Đã gửi",
    "create": "Tạo",
    "tasks": "Nhiệm vụ | Nhiệm vụ",
    "emails": "Email | Email",
    "passwords": "Mật khẩu | Mật khẩu",
    "limits": "Giới hạn",
    "assignee": "Người được giao",
    "comment": "Bình luận",
    "issue": "Sự cố",
    "urgent": "Khẩn cấp",
    "retry": "Thử lại",
    "custom": "Tùy chỉnh",
    "na": "Không áp dụng"
  },
  "phrases": {
    "copyToClipboard": "Sao chép vào bộ nhớ tạm",
    "copiedToClipboard": "Đã sao chép vào bộ nhớ tạm",
    "warehouseAddress": "Địa chỉ kho hàng",
    "cloneSchedule": "Sao chép lịch",
    "open24Hours": "Mở cửa 24 giờ",
    "featureEnabled": "Đã bật tính năng",
    "featureDisabled": "Đã tắt tính năng",
    "learnMore": "Tìm hiểu thêm",
    "minuteLabel": "{minutes} PHÚT",
    "minuteLabelFull": "{minutes} phút",
    "thisActionCannotBeUndone": "thao tác này KHÔNG THỂ hoàn tác",
    "areYouSure": "Bạn có chắc chắn không?",
    "unknownUser": "Người dùng không xác định",
    "leaveWithoutSaving": "Rời đi mà không lưu",
    "learnHowItWorks": "Tìm hiểu cách hoạt động",
    "allFields": "Tất cả các trường",
    "selectColumns": "Chọn cột",
    "selectedColumns": "Cột đã chọn",
    "addFiles": "Thêm tệp | Thêm tệp",
    "tasks": "Không có nhiệm vụ | {count} nhiệm vụ | {count} nhiệm vụ",
    "driversSelfCheckin": "Tài xế tự check-in",
    "addReferenceNumber": "Thêm số tham chiếu",
    "myAccount": "Tài khoản của tôi"
  },
  "messages": {
    "theConfirmationFieldDoesNotSupportPasting": "Trường xác nhận không hỗ trợ dán",
    "youMayHaveUnsavedChangesAreYouSureYouWantToLeaveThisPage": "Bạn có thể có thay đổi chưa được lưu, bạn có chắc chắn muốn rời khỏi trang này không?",
    "browserDoesNotSupportCopyFunction": "Trình duyệt không hỗ trợ chức năng sao chép",
    "permissionToAccessClipboardWasDeniedToEnableAccessUpdateYourBrowserSettings": "Quyền truy cập bộ nhớ tạm đã bị từ chối. Để cho phép truy cập, hãy cập nhật cài đặt trình duyệt của bạn.",
    "alternativelyYouCanManuallyCopy": "Ngoài ra, bạn có thể sao chép thủ công",
    "areYouSureYouWantToLeaveYouMayHaveUnsavedChanges": "Bạn có chắc chắn muốn rời đi không? Bạn có thể có thay đổi chưa được lưu.",
    "noResultsFound": "Không tìm thấy kết quả",
    "maximumOfReferenceNumbersAllowedCountRemoved": "Cho phép tối đa {maxItems} số tham chiếu. Đã xóa {removedCount}"
  },
  "fileFormats": {
    "jpeg": "jpeg",
    "jpg": "jpg",
    "png": "png",
    "webp": "webp",
    "pdf": "pdf"
  },
  "specialtyTerms": {
    "opendock": "Opendock",
    "warehouses": "Kho hàng | Kho hàng",
    "carrierContacts": "Liên hệ hãng vận chuyển | Liên hệ hãng vận chuyển",
    "loadTypes": "Loại hàng | Loại hàng",
    "docks": "Cửa kho | Cửa kho",
    "appointments": "Cuộc hẹn | Cuộc hẹn",
    "users": "Người dùng | Người dùng",
    "organizations": "Tổ chức | Tổ chức",
    "orgs": "Tổ chức | Tổ chức",
    "companies": "Công ty | Công ty",
    "referenceNumber": "Số tham chiếu",
    "refNumber": "Số tham chiếu",
    "status": "Trạng thái",
    "orgLoadTypes": "Loại hàng của tổ chức",
    "schedulingPortal": "Cổng đặt lịch",
    "customFields": "trường tùy chỉnh | trường tùy chỉnh",
    "interval": "Khoảng thời gian",
    "drivers": "Tài xế | Tài xế",
    "carriers": "Hãng vận chuyển | Hãng vận chuyển",
    "tags": "Thẻ | Thẻ",
    "yardManagement": "Quản lý bãi",
    "carrier": "hãng vận chuyển | hãng vận chuyển",
    "assets": "Tài sản | Tài sản",
    "tvMode": "Chế độ TV",
    "gridView": "Dạng lưới",
    "listView": "Dạng danh sách",
    "gateManagement": "Quản lý cổng",
    "selfCheckIn": "tự check-in",
    "gateFeed": "Luồng sự kiện cổng"
  },
  "appointmentStatuses": {
    "NoShow": "Vắng mặt",
    "Cancelled": "Đã hủy",
    "Requested": "Đã yêu cầu",
    "Scheduled": "Đã lên lịch",
    "Arrived": "Đã đến",
    "InProgress": "Đang xử lý",
    "Completed": "Đã hoàn tất",
    "Reserves": "Lịch giữ chỗ"
  },
  "appointmentTypes": {
    "standard": "Tiêu chuẩn",
    "reserved": "Đã giữ chỗ",
    "reserve": "Giữ chỗ"
  },
  "appointmentCreatorTypes": {
    "warehouseUser": "Người dùng kho hàng",
    "carrier": "Hãng vận chuyển"
  },
  "roles": {
    "base": "Cơ bản",
    "carrier": "Hãng vận chuyển",
    "carrierAdmin": "Quản trị viên hãng vận chuyển",
    "spectator": "Người xem",
    "attendant": "Nhân viên trực",
    "operator": "Người vận hành",
    "admin": "Quản trị viên",
    "owner": "Chủ sở hữu",
    "internal": "Nội bộ",
    "god": "Toàn quyền"
  },
  "weekdays": {
    "sunday": "Chủ Nhật",
    "monday": "Thứ Hai",
    "tuesday": "Thứ Ba",
    "wednesday": "Thứ Tư",
    "thursday": "Thứ Năm",
    "friday": "Thứ Sáu",
    "saturday": "Thứ Bảy"
  },
  "weekdaysAbbr": {
    "sun": "CN",
    "mon": "T2",
    "tue": "T3",
    "wed": "T4",
    "thu": "T5",
    "fri": "T6",
    "sat": "T7"
  },
  "buttons": {
    "nevermind": "Thôi",
    "select": "Chọn",
    "confirm": "Xác nhận",
    "next": "Tiếp theo",
    "previous": "Trước",
    "create": "Tạo",
    "edit": "Chỉnh sửa",
    "save": "Lưu",
    "send": "Gửi",
    "yesDelete": "Có, xóa",
    "skipCreation": "Bỏ qua tạo mới",
    "cancel": "Hủy",
    "export": "Xuất",
    "saveChanges": "Lưu thay đổi",
    "exportData": "Xuất dữ liệu",
    "resetToDefault": "Đặt lại mặc định"
  },
  "tooltips": {
    "notAvailable": "Không khả dụng",
    "notAvailableForUserRole": "Không khả dụng cho vai trò người dùng của bạn."
  },
  "errors": {
    "unkownError": "Đã xảy ra lỗi không xác định.",
    "thisFieldIsRequired": "Trường này là bắt buộc",
    "passwordDoesNotMeetRequirements": "Mật khẩu không đáp ứng yêu cầu về mật khẩu",
    "emailMustBeValid": "Email phải hợp lệ",
    "pleaseEnterAValidPhoneNumber": "Vui lòng nhập số điện thoại hợp lệ",
    "pleaseEnterAValidUrl": "Vui lòng nhập URL hợp lệ",
    "invalidHour": "Giờ không hợp lệ",
    "invalidMinute": "Phút không hợp lệ",
    "pleaseSelectAmOrPm": "Chọn AM hoặc PM",
    "pleaseEnterACompleteDateAndTime": "Nhập đầy đủ ngày và giờ",
    "mustBeANumber": "Phải là một số",
    "mustBeAPositiveInteger": "Phải là số nguyên dương",
    "mustBeAWholeNumber": "Phải là số nguyên",
    "isNotAValidNumber": "không phải là số hợp lệ",
    "invalidUuid": "UUID không hợp lệ",
    "dateMustNotBeInThePast": "Ngày không được ở trong quá khứ",
    "mustBeWithin24HoursOfStartTime": "phải nằm trong vòng 24 giờ so với thời gian bắt đầu",
    "pleaseSelectAtLeast": "Vui lòng chọn ít nhất {requiredCount} {itemName} | Vui lòng chọn ít nhất {requiredCount} {itemName}",
    "cannotSelectMoreThan": "Không thể chọn quá {limit} {itemName} | Không thể chọn quá {limit} {itemName}",
    "fieldMustEqual": "Trường phải bằng {value}",
    "mustBeXCharacters": "Phải có {length} ký tự | Phải có {length} ký tự",
    "mustBeAtLeastXCharacters": "Phải dài ít nhất {min} ký tự | Phải dài ít nhất {min} ký tự",
    "mustBeAtMostXCharacters": "Phải dài tối đa {max} ký tự | Phải dài tối đa {max} ký tự",
    "mustBeBetweenXAndYCharactersLong": "Phải dài từ {min} đến {max} ký tự",
    "mustBeNumberBetweenXAndY": "Phải là số trong khoảng từ {min} đến {max}",
    "mustBeNumberGreaterThan": "Phải là số lớn hơn hoặc bằng {min}",
    "mustBeNumberLessThan": "Phải là số nhỏ hơn {max}",
    "mustHaveAtLeast8Characters": "Phải có ít nhất 8 ký tự",
    "mustContainUpperCaseAndLowerCase": "Phải chứa chữ hoa và chữ thường",
    "mustContainAtLeastOneLetter": "Phải chứa ít nhất một chữ cái",
    "mustContainAtLeastOneSpecialCharacter": "Phải chứa ít nhất một ký tự đặc biệt",
    "mustContainAtLeastOneNumber": "Phải chứa ít nhất một chữ số",
    "atLeastOneReferenceNumberIsRequired": "Cần có ít nhất một {refNumberDisplayName}",
    "mustBeAValidNumber": "Phải là số hợp lệ"
  },
  "warehouseAmenities": {
    "lumperServices": "Dịch vụ bốc xếp (lumper)",
    "overnightParking": "Đỗ xe qua đêm",
    "driversRestroom": "Nhà vệ sinh cho tài xế",
    "freeWiFi": "Wi-Fi miễn phí"
  },
  "warehousePPERequirements": {
    "safetyBoots": "Giày bảo hộ",
    "safetyGlasses": "Kính bảo hộ",
    "gloves": "Găng tay",
    "hardHat": "Mũ bảo hộ",
    "faceMask": "Khẩu trang",
    "noSmoking": "Cấm hút thuốc",
    "longPants": "Quần dài",
    "longSleeves": "Áo dài tay",
    "highVisibilityVest": "Áo phản quang",
    "hairAndBeardNet": "Lưới trùm tóc và râu"
  },
  "auditLog": {
    "header": "Nhật ký kiểm tra",
    "viewAuditLog": "Xem nhật ký kiểm tra",
    "noAuditLogEvents": "Không có sự kiện nào trong nhật ký kiểm tra",
    "timelineForAllUpdatesMadeToThis": "Dòng thời gian của tất cả cập nhật đối với mục này",
    "hasTheWords": "có chứa các từ",
    "eventsFromDate": "Sự kiện từ ngày",
    "searchEvents": "Tìm kiếm sự kiện",
    "by": "bởi",
    "appointmentUpdatesTimeline": "Dòng thời gian cập nhật cuộc hẹn:",
    "moreUpdates": "{count} cập nhật khác",
    "emailSubscribersUpdated": "Đã cập nhật người nhận email",
    "detailsUpdated": "Đã cập nhật chi tiết",
    "recurrenceCreated": "Đã tạo lịch lặp lại",
    "recurrenceDeleted": "Đã xóa lịch lặp lại",
    "rescheduled": "Đã đổi lịch {label}",
    "etaUpdated": "Đã cập nhật ETA",
    "emailNotifications": "Thông báo qua email",
    "carrierContactUpdated": "Đã cập nhật liên hệ hãng vận chuyển",
    "reserveTransferred": "Đã chuyển lịch giữ chỗ",
    "tagsUpdated": "Đã cập nhật thẻ",
    "scheduled": "Đã lên lịch {label}",
    "statusUpdated": "Đã cập nhật trạng thái",
    "timeUpdated": "Đã cập nhật thời gian {arrived}",
    "dwellTimeUpdated": "Đã cập nhật thời gian lưu lại",
    "everyXAtXUntilX": "Mỗi {weekDays} lúc {endTime} cho đến {endDate}",
    "opendockTeam": "Đội ngũ Opendock",
    "unknownUser": "Người dùng không xác định",
    "deleted": "Đã xóa",
    "hasBeenCleared": "đã được xóa",
    "actionUpdated": "đã cập nhật",
    "actionCreated": "Đã tạo",
    "actionDeleted": "Đã xóa",
    "noAction": "Không có thao tác",
    "emptyValue": "Giá trị trống"
  },
  "timeline": {
    "createdTheTask": "đã tạo nhiệm vụ",
    "startedTheTask": "đã bắt đầu nhiệm vụ",
    "blockedTheTask": "đã chặn nhiệm vụ",
    "unblockedTheTask": "đã bỏ chặn nhiệm vụ",
    "completedTheTask": "đã hoàn tất nhiệm vụ",
    "cancelledTheTask": "đã hủy nhiệm vụ",
    "cancelledTheReserve": "đã hủy lịch giữ chỗ",
    "cancelledTheReservationForSpot": "đã hủy giữ chỗ {areaName} - {spotCode} cho nhiệm vụ này",
    "reservedSpotForThisTask": "đã giữ chỗ {areaName} - {spotCode} cho nhiệm vụ này",
    "reservedTheSpot": "đã giữ chỗ vị trí",
    "reason": "Lý do: {reason}",
    "addedA": "đã thêm một",
    "reportedAn": "đã báo cáo một",
    "clearedThe": "đã xóa",
    "flaggedTheTask": "đã gắn cờ nhiệm vụ",
    "flaggedTheTaskAs": "đã gắn cờ nhiệm vụ là",
    "unflaggedTheTask": "đã bỏ gắn cờ nhiệm vụ",
    "unflaggedTheTaskAs": "đã bỏ gắn cờ nhiệm vụ là",
    "updatedTheTask": "đã cập nhật nhiệm vụ",
    "removedTask": "đã xóa nhiệm vụ",
    "attachments": "tệp đính kèm",
    "confirmedTheLocation": "đã xác nhận vị trí",
    "reportedAsMissing": "đã báo cáo bị thất lạc",
    "noActivityYet": "Chưa có hoạt động",
    "noAssignee": "Chưa có người được giao",
    "failedToFetchYardTaskTimeline": "Không thể tải dòng thời gian nhiệm vụ bãi",
    "failedToCreateComment": "Không thể tạo bình luận"
  },
  "yardSpotStatusDialog": {
    "headers": {
      "actionThisSpot": "{action} vị trí này?"
    },
    "dropDownItems": {
      "cleaning": "Đang vệ sinh",
      "underMaintenance": "Đang bảo trì",
      "blockedByEquipment": "Bị thiết bị chắn",
      "safetyInspection": "Kiểm tra an toàn",
      "routineInspection": "Kiểm tra định kỳ",
      "reserved": "Đã đặt trước",
      "repairsNeeded": "Cần sửa chữa",
      "damage": "Hư hỏng"
    },
    "labels": {
      "reason": "Lý do",
      "additionalNotes": "Ghi chú bổ sung"
    },
    "placeholders": {
      "selectAReason": "Chọn lý do",
      "enterAdditionalNotes": "Nhập ghi chú bổ sung"
    },
    "messages": {
      "thisSpotWillRemainUnavailable": "Vị trí này sẽ không khả dụng để gán tài sản cho đến khi được đặt lại thành mở.",
      "thisDoorWillBeSetAsOpen": "Cửa này sẽ được đặt thành mở và có thể gán tài sản trở lại.",
      "assetInTransitClosingWillBlockMove": "Tài sản {assetCode} hiện đang được di chuyển đến vị trí này. Việc đóng vị trí sẽ khiến không thể hoàn tất việc di chuyển."
    }
  },
  "tasks": {
    "presenter": {
      "unassigned": "Chưa giao",
      "noDueDate": "Không có hạn",
      "fromAnySpot": "Từ vị trí bất kỳ",
      "toAnySpot": "Đến vị trí bất kỳ",
      "anyAsset": "Tài sản bất kỳ",
      "types": {
        "move": "Di chuyển"
      },
      "status": {
        "toDo": "Cần làm",
        "inProgress": "Đang thực hiện",
        "completed": "Đã hoàn tất",
        "canceled": "Đã hủy"
      },
      "issue": "Sự cố",
      "relatedEntity": {
        "spotArea": "Khu vực",
        "spot": "Vị trí",
        "asset": "Tài sản"
      }
    }
  },
  "readyForPickupNotificationDialog": {
    "title": "Thông báo sẵn sàng lấy hàng",
    "messages": {
      "body": "Gửi email cho các liên hệ sau để thông báo rằng tài sản {assetContainerCode} đã sẵn sàng để lấy tại {warehouseName}.",
      "notificationSent": "Đã gửi thông báo thành công.",
      "notificationFailed": "Gửi thông báo thất bại. Vui lòng thử lại."
    },
    "labels": {
      "notifyTheseContacts": "Thông báo cho các liên hệ này:",
      "suggestedContacts": "Liên hệ được đề xuất:"
    },
    "buttons": {
      "skipNotification": "Bỏ qua thông báo"
    }
  }
}
